import { useEffect, useState } from "react";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { _AccountINFORPO, _Disclaimer, _RequestCredit, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    Obs: string;
    Approve: string;
}

export const CC009 = ({ configProcedure }: Props) => {

    const disclaimer = useDataBean(_Disclaimer);
    const { instance, setBean, bean } = useDataBean(_RequestCredit);
    const [props, setProps] = useState<any>({})
    const [response, setResponse] = useState<Resp>({
        Approve: "",
        Obs: "",
    })

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
        getReuqest();
    }, [configProcedure?._pocessData])

    useEffect(() => {
        if (response.Approve !== "") {
            onExportMap();
        }
    }, [response]);

    const onExportMap = () => {
        const procedure = configProcedure._procedure

        instance.updateRequestCredit({
            ...bean, 
            IDProcedureImp: procedure.IDProcedureImp,
            IDAccount: _single.getAccountID(),
            StateRequest: 1,
            IDCreditDestination: props.IDLoanDestination,
            IDLoanLine: props.IDLoanLine,
            IDCreditOpening: props.IDCreditOpening
        });

        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(response.Obs)
        }

        if (configProcedure?._pushProps) {
            configProcedure?._pushProps(response)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(response)
        }
    }

    const updateForm = (app: boolean) => {
        if (app === true) {
            setResponse(prev => ({ ...prev, Approve: `${app}`, Obs: "El usuario acepto los terminos y condiciones" }));
        } else if (app === false) {
            setResponse(prev => ({ ...prev, Approve: `${app}`, Obs: "El usuario rechazo los terminos y condiciones" }));
        }
    }

    useEffect(() => {
        getDisclaimer();
    }, [])

    const getDisclaimer = () => {
        const props = {
            Code: "REGISTRO",
            State: 1
        }
        disclaimer.instance.getDisclaimerCatalogPorPropiedades(props, null).then(
            (resp) => {
                console.log(resp)
                disclaimer.setBean(resp[0])
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const getReuqest = () => {
        const props = {
            IDProcedureImp: configProcedure._procedure.IDProcedureImp
        }
        instance.getRequestCreditCatalogPorPropiedades(props, null).then(
            (resp) => {
                const x = resp[0].DataBeanProperties;
                setBean(x);
            }
        ).catch(err => {
            toast.error(err)
        })
    }

    return (
        <div className="row">
            <span dangerouslySetInnerHTML={{ __html: disclaimer.bean?.DataBeanProperties?.Message ?? "" }} />
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-6">
                        <BasicButton eventClick={() => { updateForm(true) }} clase="success" icon="ri-check-line" children={`Aceptar`} />
                    </div>
                    <div className="col-md-6 d-flex justify-content-end">
                        <BasicButton eventClick={() => { updateForm(false) }} clase="danger" icon="ri-close-line" children={`Rechazar`} />
                    </div>
                </div>
            </div>
        </div>
    );
};